// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"eb7b0003","637":"e75e5d25","678":"5804a447","787":"66b6682d"}[chunkId] + ".chunk.js";
};